import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  SwipeableDrawer,
  Fab,
  Grid,
  List as MuiList,
  ListItemText,
  ListItem,
  ListItemIcon,
  Chip,
  ListItemSecondaryAction,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Add } from "@mui/icons-material";
import { Global } from "@emotion/react";
import useStore from "../../store/store";
import usersService from "../../services/users";
import style from "../../utils/style";
import constants from "../../utils/constants";
import { SearchBar } from "../../controls";
import NoDataFound from "../../components/NoDataFound";
import PageHeading from "../../components/PageHeading";
import AddUser from "../../components/AddUser";

function List() {
  let [keyword, setKeyword] = useState("");
  let [users, setUsers] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();
  const { token, user, setErrorMessage, setIsLoading, isLoggedIn } = useStore(
    (state) => state
  );

  useEffect(() => {
    if (!isLoggedIn) navigate("/login");
    reload();
  }, [keyword]);

  const reload = () => {
    usersService
      .reload(token, { companyId: user.companyId, keyword })
      .then((r) => {
        if (r.error) {
          setErrorMessage(r.error);
          setIsLoading(false);
          return;
        }
        if (r.data) {
          setUsers(r.data);
        }
      });
  };

  const toggleDrawer = () => setIsOpen(!isOpen);

  const Puller = styled(Box)(() => ({
    width: 30,
    height: 6,
    backgroundColor: "#ccc",
    borderRadius: 3,
    position: "absolute",
    top: 8,
    left: "calc(50% - 15px)",
  }));

  return (
    <>
      <Fab
        color="primary"
        aria-label="add"
        onClick={toggleDrawer}
        style={{ position: "fixed", right: 20, bottom: 80 }}
      >
        <Add />
      </Fab>

      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            height: `calc(60%)`,
            overflow: "visible",
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
          },
        }}
      />
      <SwipeableDrawer
        anchor="bottom"
        open={isOpen}
        onClose={toggleDrawer}
        onOpen={toggleDrawer}
        swipeAreaWidth={56}
        disableSwipeToOpen={true}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <Puller />

        <AddUser setIsOpen={toggleDrawer} reload={reload} />
      </SwipeableDrawer>

      <Grid container sx={style.container}>
        <Grid item xs={12} sx={{ mb: 1 }}>
          <PageHeading text="Users" />
        </Grid>

        <Grid item xs={12}>
          <SearchBar keyword={keyword} setKeyword={setKeyword} />
        </Grid>

        {users.length > 0 && (
          <Grid item xs={12} md={12} sx={{ mt: 2 }}>
            <MuiList
              sx={{
                width: "100%",
                bgcolor: "background.paper",
                p: 0,
                m: 0,
              }}
            >
              {users.map((row, idx) => (
                <ListItem key={idx} sx={{ m: 0, p: 1 }}>
                  {row.type === "owner" && (
                    <ListItemSecondaryAction sx={{ right: 1 }}>
                      <Chip
                        label="Owner"
                        size="small"
                        sx={{ fontSize: "11px" }}
                      />
                    </ListItemSecondaryAction>
                  )}
                  <ListItemIcon>
                    <ion-icon
                      name="person"
                      size={style.settingIcons}
                      style={{ color: constants.PRIMARY }}
                    ></ion-icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={row.name}
                    secondary={<a href={`tel:${row.phone}`}>{row.phone}</a>}
                  />
                </ListItem>
              ))}
            </MuiList>
          </Grid>
        )}
        {users.length === 0 && (
          <Grid item xs={12}>
            <NoDataFound />
          </Grid>
        )}
      </Grid>
    </>
  );
}

export default List;
